import { EnvEnum } from "./env-enum";
import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  production: true,
  appVersion: '1.0.0',
  env : EnvEnum.dev,
  //API: 'http://192.168.193.168:30005/v1',
  apiIdentityUrl: 'https://arete-identity-service-dev.aretelearningsystems.com.br/api/v1',
  apiManagementUrl: 'https://arete-management-core-service-dev.aretelearningsystems.com.br/api/v1',
  apiAssessmentUrl: 'https://arete-assessment-core-service-dev.aretelearningsystems.com.br/api/v1',
  apiReportUrl: 'https://arete-report-service-dev.aretelearningsystems.com.br/api/v1',
  browserCookieSessionEnabled: false,
    
  LIVEKIT_SERVER_URL : 'wss://arete-yeue9tsn.livekit.cloud',
  LIVEKIT_ARETE_API : 'https://livekit-api-dev.aretelearningsystems.com.br/api',
  LIVEKIT_ARETE_ORAL_TEST_TEMPLATE : 'https://livekit-oral-test-template.aretelearningsystems.com.br',
  LOCAL_STORAGE_KEY : "localUserGpOsce",

  // Item Management backend SERVICE ROOT (no /api/v1 — its controllers declare
  // their own prefix, and some carry api/v1 while others do not).
  apiItemManagementUrl: 'https://api-item-manager-dev.aretelearningsystems.com.br',

  // Verified 2026-08-25: serves a real remoteEntry.json exposing `./routes`.
  itemManagerRemoteEntry: 'https://item-manager-dev.aretelearningsystems.com.br/remoteEntry.json',
  itemManagementLegacyRoutes: true,



  // Cutover ON in dev only. There is no frontend ConfigMap in any environment
  // (the Deployment has no env/envFrom), so environment.dev.ts is baked into the
  // bundle: flipping this back to false is a rebuild + redeploy, not a kubectl edit.
  featureFlags: {
    itemManagement: true,
    simulatedStationOrders: true,
    myActivities: false,
    adminExperience: false,
    itemManagementSlices: {
      items: true,
      authoring: true,
      review: true,
    },
  },
  // Production flow follow-up e-mail reminders: prepared, not implemented (#704 §C).
  features: {
    productionFlowEmailReminders: false,
    acompanhamentoUnificado: true,
  },

  // Feature flag: render the left sidebar menu. Disabled by default.
  sidebarEnabled: false,
  tracing: {
    enabled: true,
    collectorUrl: 'https://otel-dev.aretelearningsystems.com.br/v1/traces',
    sampleRatio: 0.1,
    serviceName: 'arete-frontend',
  },
  SENTRY_ENV : "dev",
  SENTRY_RATE : 0.5,
  turnstile: {
    enabled: false,
    siteKey: '1x00000000000000000000AA'
  },
  cookieConsent: {
    enabled: false
  },
  terms: {
    legacyHtmlFallback: true
  }
};
